import { useEffect, useState } from "react";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { ColumnSortOption } from "../../../Component/Model/Dto/ColumnSortOption";
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import config from "../../../config";
import { useRecoilState} from 'recoil';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';
import { useHistory } from 'react-router-dom';
import { GeneratedCertificateRegistry } from "../../../Component/Model/Dto/GeneratedCertificateRegistry";
import { GeneratedCertificateRegistryTableMapper } from "./GeneratedCertificateRegistryTable";
import { GeneratedCertificateRegistryService } from "../../../Component/Api/VerificationAgency/GeneratedCertificateRegistry/GeneratedCertificateRegistryService";

export const GeneratedCertificateRegistryPage = () => {

    const [data, setData] = useState<GeneratedCertificateRegistry.SearchResult[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>('');
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
    const [company, setCompany] = useRecoilState(VerificationCompanyAtom);
    const history = useHistory();

    const searchRequest: GeneratedCertificateRegistry.SearchRequest = {
        columnSortOptions: columnSortOptions,
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue as number,
        searchValue: ""
    };


    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions([sortOption]);
        setPageNumber(1);
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let response = await GeneratedCertificateRegistryService.Search(searchRequest);
            setData(response.data.results);
            setFilteredItemsCount(response.data.filteredItemsCount);
            setTotalItemsCount(response.data.totalItemsCount);
        } catch (error) { }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, searchValue, pageNumber, columnSortOptions]);

    const handleViewCertificate = (id: string) => {
        const url = `${config.apiUrl}/BeeVACertificate/DownloadVerificationCertificate?certificateId=${id}`;
        window.open(url);
    }

    const handleRouteToCompany = (companyId: number, name:string) => {
        setCompany({...company, vaClientId: companyId , company:name});
        history.push(`/company/details/company`);
    }

    const tableData = GeneratedCertificateRegistryTableMapper(data, handleViewCertificate, handleRouteToCompany);

    return (
        <>
            <DataTable
                table={tableData}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                isLoading={isLoading}
                canSearch={true}
                searchValueChanged={searchValueChanged}
                manualSorting={true}
                columnSortingChanged={columnSortingChanged}
            />
        </>
    )
}
